import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { IncidentTimlineGraphComponent } from 'src/app/common/modules/charts/components/incident-timline-graph/incident-timline-graph.component';
import { ISelectedAttachments } from 'src/app/common/modules/dialog-pop-ups/components/lodge-complaint-diaog/lodge-complaint-diaog.component';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import { SnoozeIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/snooze-incident-dialog/snooze-incident-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IAssets } from 'src/app/models/assets';
import { IIncidents } from 'src/app/models/incident';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { UserRegDetails } from 'src/app/models/user';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
import {
  AllowedTransitions,
  EnumToStatusString,
  IncidentStatusEnum,
} from 'src/app/enums/incidentStatus.enum';
@Component({
  selector: 'app-incident-detail',
  templateUrl: './incident-detail.component.html',
  styleUrls: ['./incident-detail.component.scss'],
})
export class IncidentDetailComponent implements OnInit {
  @Input() set OrgAssets(val: IAssets[]) {
    this.orgAssetList = val;
  }
  @Input() isOnlyView: boolean = false;
  @Input() selectedCommentId: string | null;
  @Input() set complainDetails(val: ComplaintsTickets) {
    if (val) {
      this.complainDetail = val;
      this.isService = true;
      this.isComplainOrClaim = false;
      if (val.complainSubject == 'Complain' || val.complainSubject == 'Claim') {
        this.isComplainOrClaim = true;
      }
      if (val.evidence) {
        this.isMultipleEvidence = true;
        this.complainEvidence = JSON.parse(val.evidence);
        // this.onShowEvidence(this.complainEvidence[0]);
      } else {
        this.isMultipleEvidence = false;
        this.complainEvidence = [];
      }
    }
  }
  @Input() set incidentDetails(val: IIncidents) {
    if (val) {
      setTimeout(() => {
        this.setIncidentDetails(val);
      }, 100);
    }
  }
  @Input() set orgUser(val: UserRegDetails[]) {
    this.usersList = val;
    this.filteredUserList = this.usersList;
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredUserList = this.filterHosts(value);
      if (value === null || value === '') {
        // this.hostFilter.setValue(this.incidentDetail.eventCreatedBy, {
        //   emitEvent: false,
        // }); // Set the value back to assignedTo without emitting an event
      } else {
        // Otherwise, filter the user list based on the value
        this.filteredUserList = this.filterHosts(value);
      }
    });
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredUserList = this.filterHosts(value);
      if (value === null || value === '') {
        // this.selectedUsersControl.setValue(this.incidentDetail.assignedTo, {
        //   emitEvent: false,
        // }); // Set the value back to assignedTo without emitting an event
      } else {
        // Otherwise, filter the user list based on the value
        this.filteredUserList = this.filterHosts(value);
      }
    });
  }
  @Output() postIncidentComment = new EventEmitter<any>();
  @Output() closeIncidentDetail = new EventEmitter<boolean>();
  @Output() snoozeIncident = new EventEmitter<any>();
  @Output() showTimeline = new EventEmitter<any>();
  @Output() onGetUpdatedRequests = new EventEmitter<any>();

  @ViewChild('OnZoomDialog', { static: true }) onZoomDialog: TemplateRef<any>;
  @ViewChild('OnUpdateAssign', { static: true })
  onUpdateAssign: TemplateRef<any>;
  orgAssetList: IAssets[] = [];
  incidentOptions: string[] = [
    'Abandoned Object',
    'ANPR Unverified',
    'ANPR Verified',
    'Claims',
    'Communication Failure',
    'Device Faulty',
    'Device Offline',
    'Electricity Incident',
    'Face Unverified',
    'Face Verified',
    'Fire',
    'General Activity',
    'Housekeeping',
    'Incident',
    'Infrastructure Damage',
    'Intrusion',
    'Link Activity',
    'Loss/Damage of Property',
    'Over Utilised Energy',
    'Plumbing Incident',
    'Possible Crime',
    'Riot/Protest',
    'Security Incident',
    'Settled Claims',
    'Suspicious Behaviour',
    'Unattended Incident',
    'Unattended SoS',
    'UncheckedOutVisitor',
    'Unidentified Person',
    'Unmonitored Asset',
    'Unmonitored logs/activity',
    'Unsettled Claims',
    'Unverified Vehicle',
    'Unverified Visitor',
    'Unauthorised/Intruded Entry',
    'Exceeded Visitor Capacity',
    'Theft/Pilferage',
    'Under Utilised Energy',

    // New incidents
    'Water Damage',
    'Structural Failure',
    'Roof Damage',
    'Glass Breakage',
    'HVAC Failure',
    'Earthquake',
    'Flood (Natural)',
    'Storm/Wind/Hail Damage',
    'Lightning Strike',
    'Wildfire',
    'Tornado/Hurricane',
    'Elevator/Escalator Malfunction',
    'Boiler or Pressure Vessel Explosion',
    'Generator or Backup Power Failure',
    'IT/Server Room Overheating or Damage',
    'Power Outage',
    'Gas Leak',
    'Water/Sewer Line Break',
    'Telecom/Internet Disruption',
    'Slip, Trip, and Fall',
    'Workplace Injury (Employee – Physical)',
    'Workplace Injury (Employee – Psychological)',
    'Visitor Injury',
    'Exposure to Hazardous Materials',
    'Fire Code Violations',
    'Contractor/3rd-party Incident',
    'Vandalism',
    'Cybersecurity Breach',
    'Trespassing/Break-in',
    'OSHA Violations',
    'Environmental Hazard',
    'Indoor Air Quality Issue',
    'Noise Pollution',
    'Hazardous Waste Spill or Leak',
    'Building Code Violations',
    'Permit/License Lapse',
    'Political Unrest/Riots Affecting Facility',
    'Regulatory Inspection Failure',
    'Health Code Violation',
    'Pandemic-related Disruption or Exposure',
    'Preventive Maintenance Missed',
    'Reactive Maintenance',
    'Inspection Failure',
    'Equipment Downtime',
    'Cleaning/Sanitation Deficiency',
    'Janitorial or Waste Management Lapse',
    'Delayed Repair Due to Vendor',
    'Defective Replacement Part',
    'Subcontractor Default',
    'Supply Chain Disruption',
    'Open Litigation/Dispute',
    'Fraudulent or Exaggerated Claim',
    'Insurance Lapse or Policy Gaps',
    'Denied Claim',
    'Subrogation Case',
    'IT – Data Loss or Corruption',
    'IT - Data Breach',
    'IT – Software Failure or Malfunction',
    'IT – Software Bug or Defect',
    'IT – Hardware Failure or Breakdown',
    'Untrained Staff Operating Equipment',
    'Emergency Exit Blocked or Malfunctioning',
    'Active Shooter or Armed Intruder Incident',
    'Bomb Threat or Suspicious Package',
    'Alarm System Malfunction',
    'Surveillance System Failure',
    'Fire Suppression System Failure',
    'Utility Misuse or Tampering',
    'Parking Lot Accident or Safety Hazard',
    'Ergonomic Injury or Musculoskeletal Claim',
    'Lockout/Tagout Procedure Violation',
    'Threshold Breach'
  ];
  currentStatus: IncidentStatusEnum;
  statusError: string = '';
  selectedUsersControl = new FormControl();
  usersTemp: string[] = [];
  hostFilter = new FormControl();
  isService: boolean = false;
  isAssignedToMe: boolean = false;
  isComplainOrClaim: boolean = false;
  complainDetail: ComplaintsTickets;
  evidence = '';
  complainEvidence: { FileName: string; FileType: string; Url: string }[];
  incidentEvidence: {
    FileName: string;
    FileType: string;
    Url: string;
    EvidenceId: string;
    CommentId: string;
  }[];
  removedIncidentEvidence: {
    FileName: string;
    FileType: string;
    Url: string;
    EvidenceId: string;
    CommentId: string;
  }[] = [];
  orgId: string = null;
  incidentDetail: IIncidents;
  IdentityId = '';
  isRecuringIncident = false;
  isSameReporter = false;
  isIncidentDescription = false;
  isTimeline = false;
  isShowTime = false;
  isUpdateIncident = false;
  usersList: UserRegDetails[] = [];
  filteredUserList: UserRegDetails[] = [];
  showIncidentDetailsForm = this.formbuilder.group({
    incidentId: [''],
    incidentName: [''],
    incidentType: [''],
    incidentLocation: [''],
    incidentDescription: [''],
    sourceAsset: [''],
    sourceAssetId: [''],
    incidentStatus: [''],
    incidentCriticality: [''],
    assignedTo: [''],
    assignedToUserId: [''],
    eventEvidence: [''],
    eventCreatedBy: [''],
    eventCreateDate: [''],
    eventClosedDate: [''],
    eventCreatedByUserID: [''],
    isManualEvent: [''],
    eventSnoozeDeadline: [''],
    eventOwnerName: [''],
    eventOwnerEmail: [''],
    eventOwnerPhone: [''],
    attachments: [],
    isLocationAdded: [false],
    previousSelectedUsers: this.formbuilder.array([]),
    selectedUsers: this.formbuilder.array([]),
  });
  screenSize: ScreenType;
  isShowReporter: boolean = false;
  isMultipleEvidence: boolean = false;
  isMultipleIncidentEvidence = false;
  baseServerURL = environment.apiUrl;
  loggedUser: UserDetailsToken;

  constructor(
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngOnInit(): void {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.orgId = this.loggedUser.organizationID;
  }
  onStatusChange(event: any): void {
    const newStatus = +event.value as IncidentStatusEnum;
    const allowed = AllowedTransitions[this.currentStatus] || [];

    if (!allowed.includes(newStatus) && newStatus !== this.currentStatus) {
      this.statusError = `❌ Invalid transition from "${
        EnumToStatusString[this.currentStatus]
      }" to "${EnumToStatusString[newStatus]}"`;
      this.showIncidentDetailsForm.get('incidentStatus')?.setValue(null); // Reset selection
    } else {
      this.statusError = '';
      this.showIncidentDetailsForm
        .get('incidentStatus')
        ?.setValue(newStatus.toString());
    }
  }
  setIncidentDetails(val: IIncidents) {
    if (!this.loggedUser) {
      this.loggedUser = this.encryptionService.getCurrentUser();
      this.orgId = this.loggedUser.organizationID;
    }
    this.evidence = '';
    this.usersTemp = [];
    this.selected.clear();
    this.previousSelected.clear();
    this.isUpdateIncident = false;
    this.incidentDetail = val;
    this.currentStatus = this.incidentDetail.incidentStatus; // assuming this is the current one
    this.showIncidentDetailsForm.reset();
    this.isIncidentDescription = false;
    this.isMultipleIncidentEvidence = false;
    this.isService = false;
    this.removedIncidentEvidence = [];
    this.isRemoveEvidence = false;
    this.isNewEvidence = false;
    this.isRecuringIncident = false;
    this.selectedMultipleAttachment = [];
    if (val.multipleEvidence && val.multipleEvidence.length > 10) {
      this.isMultipleIncidentEvidence = true;
      this.incidentEvidence = JSON.parse(val.multipleEvidence);
    }
    if (val.anprDetectDateTime || val.faceDetectDateTime) {
      this.isTimeline = true;
    }
    this.isRecuringIncident = val.isRecurring;
    this.isSameReporter =
      this.loggedUser.userID.toLowerCase() ===
      val.eventCreatedByUserID.toLowerCase();
    if (val.incidentDescription) {
      this.isIncidentDescription = true;
    }
    this.showIncidentDetailsForm.controls.incidentDescription.setValue(
      val.incidentDescription
    );
    this.showIncidentDetailsForm.controls.incidentId.setValue(val.incidentId);
    this.showIncidentDetailsForm.controls.incidentName.setValue(
      (this.isService || this.incidentDetail?.isRequest == 1) &&
        this.complainDetail?.requestType
        ? this.complainDetail.requestType
        : val.incidentName
    );
    this.showIncidentDetailsForm.controls.incidentType.setValue(
      val.incidentType.toUpperCase()
    );
    if (val.assignedUsers != null) {
      let assigneeList: any[] = JSON.parse(val.assignedUsers);
      if (assigneeList.length > 0) {
        assigneeList.forEach((x) => {
          this.usersTemp.push(x.UserName);
          this.showIncidentDetailsForm.controls.assignedTo.setValue(
            this.usersTemp.join(',')
          );
          if (x.UserId.toLowerCase() === this.loggedUser.userID.toLowerCase()) {
            this.isAssignedToMe = true; // If a match is found, set to true
          } else {
            this.isAssignedToMe = false;
          }
        });
        setTimeout(() => {
          if (assigneeList.length != this.previousSelected.length) {
            assigneeList.forEach((x) => {
              this.updatePreviousUser(x.UserId);
            });
          }
        }, 1500);
      }
    }

    try {
      this.showIncidentDetailsForm.controls.incidentLocation.setValue(
        val.incidentLocation ? JSON.parse(val.incidentLocation)[0]?.label : ''
      );
    } catch (e) {
      // If JSON.parse fails, log the error and set the value to an empty string
      console.warn('Error parsing incidentLocation:', e);
      this.showIncidentDetailsForm.controls.incidentLocation.setValue(
        val.incidentLocation
      );
    }
    this.showIncidentDetailsForm.controls.sourceAssetId.setValue(
      val.sourceAssetId
    );
    this.showIncidentDetailsForm.controls.sourceAsset.setValue(val.sourceAsset);
    const statusMap: any = {
      0: 'Open',
      1: 'Close',
      2: 'Verified',
      3: 'Snoozed',
      4: 'In-Progress',
      5: 'On-Hold',
      6: 'Approved',
      7: 'Rejected',
      8: 'Completed',
    };
    const incidentStatus: any = val.incidentStatus;
    const status = statusMap.hasOwnProperty(incidentStatus)
      ? statusMap[incidentStatus]
      : 'Not Specified';

    this.showIncidentDetailsForm.controls.incidentStatus.setValue(status);
    this.evidence = val.eventEvidence;
    this.isImage = true;
    this.showIncidentDetailsForm.controls.incidentCriticality.setValue(
      val.incidentCriticality
    );
    this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
      val.assignedToUserId
    );
    this.showIncidentDetailsForm.controls.eventCreatedBy.setValue(
      val.eventCreatedBy
    );
    this.showIncidentDetailsForm.controls.eventCreatedByUserID.setValue(
      val.eventCreatedByUserID
    );
    this.isShowReporter = val.incidentType.toUpperCase() != 'AUTOMATIC';
    this.isShowTime = false;
  }
  onShowTimeline() {
    this.isShowTime = !this.isShowTime;
    this.showTimeline.emit(this.isShowTime);
  }
  onClose() {
    this.closeIncidentDetail.emit();
  }
  isFirstReporterClick = false;
  isFirstClick = false;
  onEdit() {
    this.isUpdateIncident = true;
  }
  onInputhostFilterClick() {
    if (!this.isFirstReporterClick)
      this.hostFilter.setValue(this.incidentDetail.eventCreatedBy);
    this.isFirstReporterClick = true;
  }
  onInputselectedUsersControlClick() {
    if (!this.isFirstClick)
      this.selectedUsersControl.setValue(this.incidentDetail.assignedTo);
    this.isFirstClick = true;
  }
  onClicktoZoom() {
    const dialogRef = this.dialog.open(this.onZoomDialog, {
      height: '600px',
      width: '960px',
    });
    dialogRef.afterClosed().subscribe((x) => {
      this.isFile = false;
    });
  }
  getDistinctSelectedUsers(): any[] {
    const selectedUsers =
      this.showIncidentDetailsForm.controls.selectedUsers.value;
    const previousSelectedUsers =
      this.showIncidentDetailsForm.controls.previousSelectedUsers.value;
    // Return the users that are in selectedUsers but not in previousSelectedUsers
    const distinctSelectedUsers = selectedUsers.filter(
      (user: any) =>
        !previousSelectedUsers.some(
          (prevUser: any) => prevUser.HostUserId === user.HostUserId
        )
    );

    return distinctSelectedUsers;
  }
  getRemovedPreviousSelectedUsers(): any[] {
    const selectedUsers =
      this.showIncidentDetailsForm.controls.selectedUsers.value;
    const previousSelectedUsers =
      this.showIncidentDetailsForm.controls.previousSelectedUsers.value;

    // Return the users that are in previousSelectedUsers but not in selectedUsers
    const distinctPreviousSelectedUsers = previousSelectedUsers.filter(
      (user: any) =>
        !selectedUsers.some(
          (selectedUser: any) => selectedUser.HostUserId === user.HostUserId
        )
    );

    return distinctPreviousSelectedUsers;
  }

  isSelectedAssigneeChanged(): boolean {
    const selected = this.selected.value || [];
    const assigneeList: any[] = this.incidentDetail.assignedUsers
      ? JSON.parse(this.incidentDetail.assignedUsers)
      : [];

    // If no assignees were previously assigned and now some are selected
    if (!this.incidentDetail.assignedUsers && selected.length > 0) {
      return true;
    }

    // Compare count first — if different, change happened
    if (assigneeList.length !== selected.length) {
      return true;
    }

    // Compare the sets of IDs
    const originalIds = new Set(
      assigneeList.map((a) => a.UserId.toLowerCase())
    );
    const selectedIds = new Set(
      selected.map((s: any) => s.HostUserId.toLowerCase())
    );

    for (let id of originalIds) {
      if (!selectedIds.has(id)) {
        return true; // Existing assignee was removed
      }
    }

    for (let id of selectedIds) {
      if (!originalIds.has(id)) {
        return true; // New assignee was added
      }
    }

    return false; // Nothing changed
  }

  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        let isLocationChanged = false;
        try {
          // this.showIncidentDetailsForm.controls.incidentLocation.setValue(
          //   val.incidentLocation ? JSON.parse(val.incidentLocation)[0]?.label : ''
          // );
          isLocationChanged =
            (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
              '') !=
            (JSON.parse(val.incidentLocation)[0]?.label?.toLowerCase() ?? '');
        } catch (e) {
          // If JSON.parse fails, log the error and set the value to an empty string
          console.warn('Error parsing incidentLocation:', e);
          isLocationChanged =
            (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
              '') != (val.incidentLocation?.toLowerCase() ?? '');
        }
        let data = {
          isSnooze: true,
          durationType: result.durationType,
          durationSize: result.durationSize,
          incidentId: val.incidentId,
          orgId: val.orgId,
          incidenType: val.incidentType,
          eventCreatedBy:
            this.showIncidentDetailsForm.controls.eventCreatedBy.value,
          eventCreatedByUserID:
            this.showIncidentDetailsForm.controls.eventCreatedByUserID.value,
          assignedToUserId: val.assignedToUserId,
          evidence: val.eventEvidence,
          incidentStatusTimeline: this.incidentDetail.incidentStatusTimeline,
          isAssigned: this.isSelectedAssigneeChanged(),
          isReporterChanged:
            (this.showIncidentDetailsForm.controls.eventCreatedByUserID.value?.toLowerCase() ??
              '') !=
            (this.incidentDetail.eventCreatedByUserID?.toLowerCase() ?? ''),
          isStatusChanged: true,
          isIncidentNameChanged:
            (this.showIncidentDetailsForm.controls.incidentName.value?.toLowerCase() ??
              '') != (this.incidentDetail.incidentName?.toLowerCase() ?? ''),

          isIncidentTypeChanged:
            (this.showIncidentDetailsForm.controls.incidentType.value?.toLowerCase() ??
              '') != (this.incidentDetail.incidentType?.toLowerCase() ?? ''),

          isIncidentSourceChanged:
            (this.showIncidentDetailsForm.controls.sourceAssetId.value?.toLowerCase() ??
              '') != (this.incidentDetail.sourceAssetId?.toLowerCase() ?? ''),

          isIncidentLocationChanged: isLocationChanged,

          isIncidentDescriptionChanged:
            (this.showIncidentDetailsForm.controls.incidentDescription.value?.toLowerCase() ??
              '') !=
            (this.incidentDetail.incidentDescription?.toLowerCase() ?? ''),

          isIncidentCriticalityChanged:
            (this.showIncidentDetailsForm.controls.incidentCriticality.value?.toLowerCase() ??
              '') !=
            (this.incidentDetail.incidentCriticality?.toLowerCase() ?? ''),

          isNewEvidence: this.isNewEvidence,
          assignedTo: this.showIncidentDetailsForm.controls.assignedTo.value,
          incidentType:
            this.showIncidentDetailsForm.controls.incidentType.value,
          incidentName:
            this.showIncidentDetailsForm.controls.incidentName.value,
          assignedBy: this.loggedUser.fullName,
          assignedById: this.loggedUser.userID,
          incidentStatus: 3,
          incidentLocation: isLocationChanged
            ? this.showIncidentDetailsForm.controls.incidentLocation.value
            : val.incidentLocation,
          incidentCriticality:
            this.showIncidentDetailsForm.controls.incidentCriticality.value,
          sourceAsset: this.showIncidentDetailsForm.controls.sourceAssetId.value
            ? this.orgAssetList.find(
                (x) =>
                  x.assetId.toLowerCase() ==
                  this.showIncidentDetailsForm.controls.sourceAssetId.value.toLowerCase()
              ).assetName ?? null
            : null,
          sourceAssetId:
            this.showIncidentDetailsForm.controls.sourceAssetId.value,
          incidentDescription:
            this.showIncidentDetailsForm.controls.incidentDescription.value,
          eventEvidence: this.evidence,
          multipleEventEvidence:
            this.showIncidentDetailsForm.controls.attachments.value,
          eventOwnerEmail:
            this.showIncidentDetailsForm.controls.eventOwnerEmail.value,
          selectedUsers:
            this.showIncidentDetailsForm.controls.selectedUsers.value,
          previousSelectedUsers:
            this.showIncidentDetailsForm.controls.previousSelectedUsers.value,
          distinctsSelectedUsers: this.getDistinctSelectedUsers(),
          removedPreviousUsers: this.getRemovedPreviousSelectedUsers(),
        };
        if (result) {
          this.snoozeIncident.emit(data);
        }
      } else {
        this.dialog.closeAll();
      }
    });
  }
  onChangeAssignee(val: any) {
    const tempuser: UserRegDetails = this.usersList.filter(
      (x) => x.userId == val
    )[0];
    this.showIncidentDetailsForm.controls.assignedTo.setValue(val);
    this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
      tempuser.firstname + ' ' + tempuser.lastname
    );
    this.showIncidentDetailsForm.controls.eventOwnerEmail.setValue(
      tempuser.email
    );
  }
  isRemoveEvidence = false;
  onRemoveEvidence(index: number, val: any): void {
    this.incidentEvidence.splice(index, 1);
    this.removedIncidentEvidence.push(val);
    this.isRemoveEvidence = true;
  }
  onRemoveSelectedEvidence(index: number): void {
    this.selectedMultipleAttachment.splice(index, 1);
  }
  onUpdate() {
    const incidentStatusControl: string =
      this.showIncidentDetailsForm.controls.incidentStatus.value;
    let status: number;
    if (incidentStatusControl == '0' || incidentStatusControl == 'Open') {
      status = 0;
    }
    if (incidentStatusControl == '1' || incidentStatusControl == 'Close') {
      status = 1;
    }
    if (incidentStatusControl == '2' || incidentStatusControl == 'Verified') {
      status = 2;
    }
    if (incidentStatusControl == '3' || incidentStatusControl == 'Snoozed') {
      status = 3;
    }
    if (
      incidentStatusControl == '4' ||
      incidentStatusControl == 'In-Progress'
    ) {
      status = 4;
    }
    if (incidentStatusControl == '8' || incidentStatusControl == 'Completed') {
      status = 8;
    }
    if (incidentStatusControl == '5' || incidentStatusControl == 'On-Hold') {
      status = 5;
    }
    if (incidentStatusControl == '6' || incidentStatusControl == 'Approved') {
      status = 6;
    }
    if (incidentStatusControl == '7' || incidentStatusControl == 'Rejected') {
      status = 7;
    }
    let isStatusChangedRecently = status != this.incidentDetail.incidentStatus;
    this.dialog.open(this.onUpdateAssign),
      {
        disableClose: false,
      };
    if (status == 3 && isStatusChangedRecently) {
      this.onSnoozeIncident(this.incidentDetail);
    } else {
      let isLocationChanged = false;
      try {
        isLocationChanged =
          (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
            '') !=
          (JSON.parse(
            this.incidentDetail.incidentLocation
          )[0]?.label?.toLowerCase() ?? '');
      } catch (e) {
        // If JSON.parse fails, log the error and set the value to an empty string
        console.warn('Error parsing incidentLocation:', e);
        isLocationChanged =
          (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
            '') != (this.incidentDetail.incidentLocation?.toLowerCase() ?? '');
      }
      let data = {
        isSnooze: false,
        isAssigned: this.isSelectedAssigneeChanged(),
        isReporterChanged:
          (this.showIncidentDetailsForm.controls.eventCreatedByUserID.value?.toLowerCase() ??
            '') !=
          (this.incidentDetail.eventCreatedByUserID?.toLowerCase() ?? ''),
        eventCreatedBy:
          this.showIncidentDetailsForm.controls.eventCreatedBy.value,
        eventCreatedByUserID:
          this.showIncidentDetailsForm.controls.eventCreatedByUserID.value,
        isStatusChanged: status != this.incidentDetail.incidentStatus,
        isIncidentNameChanged:
          (this.showIncidentDetailsForm.controls.incidentName.value?.toLowerCase() ??
            '') != (this.incidentDetail.incidentName?.toLowerCase() ?? ''),

        isIncidentTypeChanged:
          (this.showIncidentDetailsForm.controls.incidentType.value?.toLowerCase() ??
            '') != (this.incidentDetail.incidentType?.toLowerCase() ?? ''),

        isIncidentSourceChanged:
          (this.showIncidentDetailsForm.controls.sourceAssetId.value?.toLowerCase() ??
            '') != (this.incidentDetail.sourceAssetId?.toLowerCase() ?? ''),

        isIncidentLocationChanged: isLocationChanged,

        isIncidentDescriptionChanged:
          (this.showIncidentDetailsForm.controls.incidentDescription.value?.toLowerCase() ??
            '') !=
          (this.incidentDetail.incidentDescription?.toLowerCase() ?? ''),

        isIncidentCriticalityChanged:
          (this.showIncidentDetailsForm.controls.incidentCriticality.value?.toLowerCase() ??
            '') !=
          (this.incidentDetail.incidentCriticality?.toLowerCase() ?? ''),

        isNewEvidence: this.isNewEvidence,
        isRemoveEvidence: this.isRemoveEvidence,
        removedIncidentEvidence: this.removedIncidentEvidence,
        updatedEvidenceList: this.incidentEvidence,
        orgId: this.orgId,
        incidentId: this.showIncidentDetailsForm.controls.incidentId.value,
        assignedTo: this.showIncidentDetailsForm.controls.assignedTo.value,
        assignedToUserId:
          this.showIncidentDetailsForm.controls.assignedToUserId.value,
        incidentType: this.showIncidentDetailsForm.controls.incidentType.value,
        incidentName: this.showIncidentDetailsForm.controls.incidentName.value,
        incidentStatusTimeline: this.incidentDetail.incidentStatusTimeline,
        assignedBy: this.loggedUser.fullName,
        assignedById: this.loggedUser.userID,
        incidentStatus: status,
        incidentLocation: isLocationChanged
          ? this.showIncidentDetailsForm.controls.incidentLocation.value
          : this.incidentDetail.incidentLocation,
        incidentCriticality:
          this.showIncidentDetailsForm.controls.incidentCriticality.value,
        sourceAsset: this.showIncidentDetailsForm.controls.sourceAssetId.value
          ? this.orgAssetList.find(
              (x) =>
                x.assetId.toLowerCase() ==
                this.showIncidentDetailsForm.controls.sourceAssetId.value.toLowerCase()
            ).assetName ?? null
          : null,
        sourceAssetId:
          this.showIncidentDetailsForm.controls.sourceAssetId.value,
        incidentDescription:
          this.showIncidentDetailsForm.controls.incidentDescription.value,
        eventEvidence: this.evidence,
        multipleEventEvidence:
          this.showIncidentDetailsForm.controls.attachments.value,
        eventOwnerEmail:
          this.showIncidentDetailsForm.controls.eventOwnerEmail.value,
        selectedUsers:
          this.showIncidentDetailsForm.controls.selectedUsers.value,
        previousSelectedUsers:
          this.showIncidentDetailsForm.controls.previousSelectedUsers.value,
        distinctsSelectedUsers: this.getDistinctSelectedUsers(),
        removedPreviousUsers: this.getRemovedPreviousSelectedUsers(),
      };
      this.snoozeIncident.emit(data);
      // this.onClose();
    }
  }
  onRemoveIncident() {
    const incidentStatusControl: string =
      this.showIncidentDetailsForm.controls.incidentStatus.value;
    let status: number;
    if (incidentStatusControl == '0' || incidentStatusControl == 'Open') {
      status = 0;
    }
    if (incidentStatusControl == '1' || incidentStatusControl == 'Close') {
      status = 1;
    }
    if (incidentStatusControl == '2' || incidentStatusControl == 'Verified') {
      status = 2;
    }
    if (incidentStatusControl == '3' || incidentStatusControl == 'Snoozed') {
      status = 3;
    }
    if (
      incidentStatusControl == '4' ||
      incidentStatusControl == 'In-Progress'
    ) {
      status = 4;
    }
    if (incidentStatusControl == '8' || incidentStatusControl == 'Completed') {
      status = 8;
    }
    if (incidentStatusControl == '5' || incidentStatusControl == 'On-Hold') {
      status = 5;
    }
    if (incidentStatusControl == '6' || incidentStatusControl == 'Approved') {
      status = 6;
    }
    if (incidentStatusControl == '7' || incidentStatusControl == 'Rejected') {
      status = 7;
    }
    let isStatusChangedRecently = status != this.incidentDetail.incidentStatus;
    this.dialog.open(this.onUpdateAssign),
      {
        disableClose: false,
      };
    let isLocationChanged = false;
    try {
      isLocationChanged =
        (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
          '') !=
        (JSON.parse(
          this.incidentDetail.incidentLocation
        )[0]?.label?.toLowerCase() ?? '');
    } catch (e) {
      // If JSON.parse fails, log the error and set the value to an empty string
      console.warn('Error parsing incidentLocation:', e);
      isLocationChanged =
        (this.showIncidentDetailsForm.controls.incidentLocation.value?.toLowerCase() ??
          '') != (this.incidentDetail.incidentLocation?.toLowerCase() ?? '');
    }
    let data = {
      isRemove: true,
      isService: this.isService || this.incidentDetail.isRequest == 1,
      isSnooze: false,
      isAssigned: this.isSelectedAssigneeChanged(),
      isReporterChanged:
        (this.showIncidentDetailsForm.controls.eventCreatedByUserID.value?.toLowerCase() ??
          '') !=
        (this.incidentDetail.eventCreatedByUserID?.toLowerCase() ?? ''),
      eventCreatedBy:
        this.showIncidentDetailsForm.controls.eventCreatedBy.value,
      eventCreatedByUserID:
        this.showIncidentDetailsForm.controls.eventCreatedByUserID.value,
      isStatusChanged: status != this.incidentDetail.incidentStatus,
      isIncidentNameChanged:
        (this.showIncidentDetailsForm.controls.incidentName.value?.toLowerCase() ??
          '') != (this.incidentDetail.incidentName?.toLowerCase() ?? ''),

      isIncidentTypeChanged:
        (this.showIncidentDetailsForm.controls.incidentType.value?.toLowerCase() ??
          '') != (this.incidentDetail.incidentType?.toLowerCase() ?? ''),

      isIncidentSourceChanged:
        (this.showIncidentDetailsForm.controls.sourceAssetId.value?.toLowerCase() ??
          '') != (this.incidentDetail.sourceAssetId?.toLowerCase() ?? ''),

      isIncidentLocationChanged: isLocationChanged,

      isIncidentDescriptionChanged:
        (this.showIncidentDetailsForm.controls.incidentDescription.value?.toLowerCase() ??
          '') != (this.incidentDetail.incidentDescription?.toLowerCase() ?? ''),

      isIncidentCriticalityChanged:
        (this.showIncidentDetailsForm.controls.incidentCriticality.value?.toLowerCase() ??
          '') != (this.incidentDetail.incidentCriticality?.toLowerCase() ?? ''),

      isNewEvidence: this.isNewEvidence,
      orgId: this.orgId,
      incidentId: this.showIncidentDetailsForm.controls.incidentId.value,
      assignedTo: this.showIncidentDetailsForm.controls.assignedTo.value,
      assignedToUserId:
        this.showIncidentDetailsForm.controls.assignedToUserId.value,
      incidentType: this.showIncidentDetailsForm.controls.incidentType.value,
      incidentName: this.showIncidentDetailsForm.controls.incidentName.value,
      incidentStatusTimeline: this.incidentDetail.incidentStatusTimeline,
      assignedBy: this.loggedUser.fullName,
      assignedById: this.loggedUser.userID,
      incidentStatus: status,
      incidentLocation: isLocationChanged
        ? this.showIncidentDetailsForm.controls.incidentLocation.value
        : this.incidentDetail.incidentLocation,
      incidentCriticality:
        this.showIncidentDetailsForm.controls.incidentCriticality.value,
      sourceAsset: this.showIncidentDetailsForm.controls.sourceAssetId.value
        ? this.orgAssetList.find(
            (x) =>
              x.assetId.toLowerCase() ==
              this.showIncidentDetailsForm.controls.sourceAssetId.value.toLowerCase()
          ).assetName ?? null
        : null,
      sourceAssetId: this.showIncidentDetailsForm.controls.sourceAssetId.value,
      incidentDescription:
        this.showIncidentDetailsForm.controls.incidentDescription.value,
      eventEvidence: this.evidence,
      multipleEventEvidence:
        this.showIncidentDetailsForm.controls.attachments.value,
      eventOwnerEmail:
        this.showIncidentDetailsForm.controls.eventOwnerEmail.value,
      selectedUsers: this.showIncidentDetailsForm.controls.selectedUsers.value,
      previousSelectedUsers:
        this.showIncidentDetailsForm.controls.previousSelectedUsers.value,
      distinctsSelectedUsers: this.getDistinctSelectedUsers(),
      removedPreviousUsers: this.getRemovedPreviousSelectedUsers(),
    };
    this.snoozeIncident.emit(data);
    this.onClose();
  }
  hostSelect(val: MatAutocompleteSelectedEvent) {
    this.usersList.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.showIncidentDetailsForm.controls.eventCreatedBy.setValue(
          item.firstname + ' ' + item.lastname
        );
        this.showIncidentDetailsForm.controls.eventCreatedByUserID.setValue(
          item.userId
        );
        // this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
        //   item.userId
        // );
        // // this.showIncidentDetailsForm.controls.eventOwnerEmail.setValue(
        // //   item.email
        // // );
        // this.showIncidentDetailsForm.controls.assignedTo.setValue(
        //   item.firstname + ' ' + item.lastname
        // );
      }
    });
    this.showIncidentDetailsForm.controls.assignedToUserId.markAsDirty();
  }
  filterHosts(value: string) {
    const filterValue = value.toLowerCase();
    return this.usersList.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  onFileSelected(event: any) {
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.evidence = event.target.result;
      };
    }
  }
  isDoc = false;
  isPdf = false;
  isImage = true;
  isNewEvidence = false;
  tempEvidence = '';
  isFile = false;
  onShowEvidence(val: any) {
    this.isPdf = false;
    this.isImage = false;
    this.isDoc = false;
    this.isFile = true;
    if (val.FileType.includes('image')) {
      this.tempEvidence = val.Url;
      this.isImage = true;
    } else if (val.FileType.includes('pdf')) {
      this.tempEvidence = val.Url;
      this.isPdf = true;
      this.isDoc = false;
    } else if (
      val.FileType.includes(
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
    ) {
      this.tempEvidence = val.Url;
      this.isDoc = true;
      this.isPdf = false;
    } else {
      this.tempEvidence = val.Url;
    }
    this.onClicktoZoom();
  }
  onDataLoaded(data: any) {
    // this.excelData = data;
    console.log('dataAddedExcel');
  }
  onShowUploadedEvidence(val: any) {
    if (val.attachedContentType.includes('image')) {
      this.evidence = val.attachedContent;
      this.isPdf = false;
    } else {
      this.evidence = val.attachedContent;
      this.isPdf = true;
    }
  }
  async onDownload(val: any) {
    try {
      const response = await fetch(val.Url);
      if (response.ok) {
        const blob = await response.blob();
        const extension = blob.type.split('/')[1];

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${val.FileName}`;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.error(error);
    }
  }
  onClickShowGraph() {
    this.dialog.open(IncidentTimlineGraphComponent, {
      data: this.incidentDetail.incidentGraph,
      width: '720px',
      height: '520px',
    });
  }
  selectedMultipleAttachment: ISelectedAttachments[] = [];
  onAttachmentSelected(event: any): void {
    this.isNewEvidence = true;
    const files: FileList = event.target.files;
    const attachedContents: string[] = []; // Array to store file contents (optional)
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      //       // Optional: Validate file type
      // const validTypes = [
      //   'application/pdf',
      //   'image/jpeg',
      //   'image/png',
      //   'application/msword', // .doc
      //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
      // ];

      // if (!validTypes.includes(file.type)) {
      //   console.warn(`Unsupported file type: ${file.name}`);
      //   continue;
      // }

      const reader = new FileReader();

      reader.onload = (e) => {
        const contents = e.target.result as string;
        attachedContents.push(contents); // Add content to the array (optional)
        this.selectedMultipleAttachment.push({
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        });
        this.showIncidentDetailsForm
          .get('attachments')
          .setValue(this.selectedMultipleAttachment);
      };
      reader.readAsDataURL(file);
      this.showIncidentDetailsForm
        .get('attachments')
        .setValue(this.selectedMultipleAttachment); // Update form control
    }
  }
  pdfLoaded = false;
  onPdfLoad() {
    this.pdfLoaded = true;
  }
  onPostIncidentComment(val: any) {
    this.postIncidentComment.emit(val);
  }
  viewIncident: string = null;
  selectedLocations: { lat: number; lng: number }[] = [];
  onClickOpenMap() {
    const dialogRef = this.dialog.open(MapsLocationDialogComponent, {
      data: { header: 'Incident Location', isMultipleMarker: false },
    });
    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.getLocationAddress(JSON.parse(x)).subscribe((response: any) => {
          if (response && response.results && response.results.length > 0) {
            const address = response.results[0].formatted_address;
            this.viewIncident = address;
            this.cdr.detectChanges();
          }
        });
        this.selectedLocations.push(JSON.parse(x));
        this.showIncidentDetailsForm.controls['incidentLocation'].setValue(
          JSON.stringify(this.selectedLocations)
        );
        this.showIncidentDetailsForm.controls['isLocationAdded'].setValue(true);
        this.cdr.detectChanges();
      }
    });
  }
  getLocationAddress(val: any) {
    const lat = val.lat;
    const lng = val.lng;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18'}`;

    return this.http.get(geocodeUrl);
  }
  get selected() {
    return this.showIncidentDetailsForm.get('selectedUsers') as FormArray;
  }
  get previousSelected() {
    return this.showIncidentDetailsForm.get(
      'previousSelectedUsers'
    ) as FormArray;
  }
  updatePreviousUser(userid: string) {
    const matchedUser = this.filteredUserList.find(
      (user) => user.userId.toLowerCase() === userid.toLowerCase()
    );
    if (matchedUser) {
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
      this.previousSelected.push(this.formbuilder.control(item));
    }
  }
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.usersList.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.showIncidentDetailsForm.get(
      'selectedUsers'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  onStopAutoAssignement() {
    const disalref = this.dialog.open(this.onUpdateAssign, {
      disableClose: false,
    });

    const data = {
      complaintId: this.incidentDetail.incidentId,
      incidentStatusTimeline: this.incidentDetail.incidentStatusTimeline,
      userId: this.loggedUser.userID,
      orgId: this.loggedUser.organizationID,
      fullname: this.loggedUser.fullName,
      incidentStatus: this.incidentDetail.incidentStatus,
    };
    let baseServerURL = this.baseServerURL + 'StopRecurringIncident';
    try {
      this.http
        .post(baseServerURL, data, {
          responseType: 'text',
        })
        .subscribe(
          (res: any) => {
            this.onGetUpdatedRequests.emit();
            disalref.close();
          },
          (err) => {
            disalref.close();
          }
        );
    } catch (e) {
      console.log(e);
    }
  }
  ScreenType = ScreenType;
}
